import { render, staticRenderFns } from "./PBXVendorInfo.vue?vue&type=template&id=8dfcd214"
import script from "./PBXVendorInfo.vue?vue&type=script&lang=js"
export * from "./PBXVendorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports